import React from 'react';
import Header from '../components/Header';
import CardQuote from '../components/CardQuote';
import Img from "../assets/vaness_four-381.webp";
import Img_sec from  "../assets/vaness_three_381.webp";
import { motion } from 'framer-motion';
import '../sass/pages/_home.scss';


export default function Home() {
    return (
        <>
            <Header />
            <main className='home'>
                <motion.section 
                    className="first"
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{ duration: 1 }}
                    viewport={{ once: true }}
                    >
                    <CardQuote
                    src={Img}
                    alt={"Une image en noir et blanc d'un trou noir"}
                    txtOne={" Faites Confiance à votre inconscient, cet immense magasin de solutions. "} authorOne={"Milton ERICKSON"}
                    txtTwo={" L'énergie de l'esprit est l'essence de la vie. "} authorTwo={"Aristote"}
                    />
                    <div className="home-txt">
                        <p>
                            Le GEST-EMDR (Gestion et Intégration des Émotions et du Stress Traumatic) est une approche thérapeutique innovante qui utilise 
                            les mouvements oculaires pour traiter les effets durables des traumatismes. Les expériences traumatisantes, qu'elles soient récentes ou anciennes, 
                            peuvent influencer notre bien-être émotionnel et mental, créant des schémas de pensée négatifs et des réactions émotionnelles intenses.
                        </p>
                    </div>
                </motion.section>
                <motion.section 
                    className="second"
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{ duration: 1, delay:.2 }}
                    viewport={{ once: true }}
                    >
                    <div className="home-txt">
                        <p>
                            Cette méthode permet de revisiter ces souvenirs difficiles dans un cadre sécurisant, favorisant une désensibilisation progressive. 
                            Au cours des séances, le praticien guide le consultant à travers des mouvements oculaires bilatéraux, facilitant ainsi l'intégration des émotions liées au 
                            traumatisme. Cela aide à atténuer la charge émotionnelle associée aux souvenirs, transformant des flashbacks envahissants en souvenirs moins perturbants.
                        </p>
                        <p>
                            Le GEST-EMDR ne se limite pas à la simple gestion des souvenirs traumatiques. Il vise également à restaurer un sentiment de contrôle et de résilience. 
                            Les consultants peuvent développer de nouvelles perspectives sur leurs expériences, renforçant ainsi leur capacité à faire face aux défis de la vie quotidienne. 
                            Grâce à cette méthode, il est possible de retrouver une paix intérieure et de rétablir des relations saines avec soi-même et avec les autres.
                        </p>
                    </div>
                </motion.section>
                <motion.section 
                    className="third"
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{ duration: 1, delay: .5 }}
                    viewport={{ once: true }}
                    >
                    <div className="home-txt">
                        <p>
                            L'hypnose est un outil pour reprendre le contrôle sur un comportement et peut être utilisée dans de nombreux domaines
                        </p>
                        <br />
                        <p>Quel que soit le sujet :</p>
                    </div>
                    <div className="home-txt-img">
                        <ul>
                            <li>Manque de confiance en soi-même</li>
                            <li>Craintes et angoisses</li>
                            <li>Fatigue, stress, anxiété</li>
                            <li>Difficultés à trouver le sommeil</li>
                            <li>Troubles de l'alimentation / compulsion</li>
                            <li>Soutien pour arrêter de fumer</li>
                            <li>Etc.</li>
                        </ul>
                        <div className='txt--img'>
                            <img src={Img_sec} alt="un bouquet de boules blanches flottant dans les airs" />
                        </div>
                    </div>
                    <div className="home-txt txt-center">
                        <p>Evidemment, elle ne peut en aucun cas remplacer une consultation médicale, mais elle est simplement une
                        aide dans votre démarche. Il est fortement recommandé de consulter un professionnel de santé avant toute
                        chose, voir indispensable dans certaines situations.</p>
                    </div>
                </motion.section>
            </main>
        </>
    )
}
